export enum CHECKOUT_EXTERNAL_SERVICES {
  syncCart = 'syncCart',
  refreshCart = 'refreshCart',
  postShippingAddress = 'postShippingAddress',
  postBillingAddress = 'postBillingAddress',
  postShippingMethod = 'postShippingMethod',
}
